<script>
export default {
	name: 'EnrichDestinationDetailsLayout',
	expose: [],
	inheritAttrs: false,
};
</script>

<script setup>
import ExperienceFragment from '~/aem-components/ExperienceFragment.vue';
import { getCompositeComponent } from '@custom/aem-vue-editable-components';
import { useGlobalAEMState } from '~/logic/aem/global-aem-state.js';
import BtnBackToTop from '~/components/BtnBackToTop.vue';
import HiddenSeamlessBookingWidget from '~/components/HiddenSeamlessBookingWidget.vue';

import { overwriteMappingWithSyncComponent } from '~/components-mapping/mapping-logic.js';

// since Banner is so common, we include it here
import Banner from '~/aem-components/Banner.vue';
import MHBreadcrumb from '~/aem-components/MHBreadcrumb.vue';

const { pageModel, pageProperties } = useGlobalAEMState();

</script>



<template>
<div class="EnrichDestinationDetailsLayout flex flex-col min-h-screen" data-layout="DestinationDetails">
	<ExperienceFragment
		class="global-mobile-download-app-notification"
		xfPath="/content/experience-fragments/enr/$lang/site/mobile-download-app-notification/master"
	/>
	<div class="sticky-spacer h-$mobileDlAppNotificationHeight"></div>
	
	<ExperienceFragment
		class="global-header-notification"
		xfPath="/content/experience-fragments/enr/$lang/site/header-notification/master"
	/>
	<div class="sticky-spacer h-$headerNotificationHeight"></div>
	
	<ExperienceFragment
		class="global-header"
		xfPath="/content/experience-fragments/enr/$lang/site/header/master"
	/>

	<HiddenSeamlessBookingWidget />
	
	<div id="content"></div>
	<div id="booking-subpage-container"></div>
	
	
	<main>
		<slot></slot>
	</main>
	
	<div class="floating-bottom-right-container">
		<ExperienceFragment
			class="global-floating-widget"
			xfPath="/content/experience-fragments/enr/$lang/site/floating-widget/master"
		/>
		<BtnBackToTop />
	</div>
	
	<ExperienceFragment
		class="global-cookies-notification"
		xfPath="/content/experience-fragments/enr/$lang/site/cookies-notification/master"
	/>
	<ExperienceFragment
		class="global-footer"
		xfPath="/content/experience-fragments/enr/$lang/site/footer/master"
	/>
</div>
</template>



<style scoped lang="scss">
@use '~/styles/partials/_var.scss';

:slotted(.page) {
	min-height: 400px;
}

</style>
